<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required />
                    @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
